{
  "title": "Clientes",
  "search": "Buscar",
  "completedUsersOnly": "Solo usuarios registrados",
  "addModal": {
    "title": "Crear nuevo cliente",
    "firstName": "Nombre",
    "middleName": "Segundo nombre",
    "lastName": "Apellido",
    "email": "Correo electrónico",
    "organization": "Organización",
    "type": "Tipo de relación",
    "createAndLinkAuthProfile": "Crear y vincular automáticamente el perfil de autenticación",
    "autoInviteUser": "Invitar automáticamente al usuario",
    "emailError": "El correo electrónico ya existe"
  },
  "table": {
    "id": "ID",
    "name": "Nombre",
    "email": "Correo electrónico",
    "suitabilityScore": "Puntuación de idoneidad",
    "completedAt": "Perfil completado",
    "organization": "Organización",
    "province": "Provincia",
    "dateOfBirth": "Fecha de nacimiento",
    "notCompleted": "Sin completar",
    "totalAssets": "Total de activos"
  },
  "auditTypes": {
    "UPDATE": "Actualizar",
    "CREATE": "Crear",
    "DELETE": "Eliminar"
  }
}
